/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    JiraIssueTypeInfo,
    JiraIssueTypeInfoFromJSON,
    JiraIssueTypeInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface JiraIssueTypesResponse
 */
export interface JiraIssueTypesResponse {
    /**
     * 
     * @type {Array<JiraIssueTypeInfo>}
     * @memberof JiraIssueTypesResponse
     */
    issueTypes: Array<JiraIssueTypeInfo>;
}

export function JiraIssueTypesResponseFromJSON(json: any): JiraIssueTypesResponse {
    return {
        
        'issueTypes': (json['issueTypes'] as Array<any>).map(JiraIssueTypeInfoFromJSON),
        
    };
}

export function JiraIssueTypesResponseToJSON(value?: JiraIssueTypesResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'issueTypes': (value.issueTypes as Array<any>).map(JiraIssueTypeInfoToJSON),
        
    };
}


